import { connect } from "react-redux";
import LoginPage from "../components/authUI/LoginPage";
import { login, getDistributorInfo, getUserPersona, generateOTP, validateOTP, ssoLogin } from "../store/actions/authActions";

const mapStatetoProps = (state) => ({
  isAuthenicated: state.auth.isAuthenicated,
  messageType: state.auth.messageType,
  msgText: state.auth.msgText,
  msgTitle: state.auth.msgTitle,
  loginError: state.auth.loginError,
  distributorName: state.auth.distributor,
  distributorImage: state.auth.distributorImage,
  relationalType: state.auth.relationalType,
  userSourceCode: state.auth.userSourceCode,
  redirect: state.auth.redirect,
});

const LoginPageContainer = connect(mapStatetoProps, {
  login,
  getDistributorInfo,
  getUserPersona,
  generateOTP,
  validateOTP,
  ssoLogin
  
})(({ ...props }) => <LoginPage {...props}></LoginPage>)

export default LoginPageContainer
